export type NewsType = "doc" | "whatsapp" | "sumi" | "info";

const NEWS_TYPES: readonly NewsType[] = ["doc", "whatsapp", "sumi", "info"];

/**
 * Anything that is not a string becomes the default.
 *
 * These fields are rendered directly, and React throws "Objects are not valid
 * as a React child" on an object or array. With no error boundary above the
 * dashboard, that takes the whole SPA down -- so one malformed news row would
 * white-screen every user until the feed was corrected.
 */
const asString = (value: any, fallback = ""): string =>
  typeof value === "string" ? value : fallback;

export class NewsModel {
  uuid: string;
  title: string;
  description: string;
  news_type: NewsType;
  button_text: string;
  button_url: string;
  image: string | null;
  created: string;
  modified: string;

  constructor(init: any = {}) {
    this.uuid = "";
    this.title = "";
    this.description = "";
    this.news_type = "info";
    this.button_text = "";
    this.button_url = "";
    this.image = null;
    this.created = "";
    this.modified = "";
    Object.assign(this, init);

    // Normalised here rather than at each render site: this is the boundary
    // the raw API JSON crosses, and news_type below has been guarded this way
    // since the model was written.
    this.uuid = asString(this.uuid);
    this.title = asString(this.title);
    this.description = asString(this.description);
    this.button_text = asString(this.button_text);
    this.button_url = asString(this.button_url);
    this.image = typeof this.image === "string" ? this.image : null;

    if (!NEWS_TYPES.includes(this.news_type)) {
      this.news_type = "info";
    }
  }
}
